import { openBlock as n, createElementBlock as e, createElementVNode as t } from "vue";
import { _ as C } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, i = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c(r, o) {
  return n(), e("svg", i, o[0] || (o[0] = [
    t("path", {
      d: "M6.11635 8.77012H6.76367M6.11635 12.654H6.76367M9.67662 8.77012H10.3239M13.2369 8.77012H13.8842M9.67662 12.654H10.3239M6.4439 1.90851V5.14512M13.5605 1.90851V5.14512M2.48876 14.5636C2.6972 16.4279 4.21193 17.9064 6.08528 17.997C7.37992 18.0592 8.70175 18.0915 10.1375 18.0915C11.5733 18.0915 12.8951 18.0592 14.1897 17.997C16.0631 17.9064 17.5778 16.4266 17.7863 14.5636C17.9274 13.3078 18.0426 12.0223 18.0426 10.7121C18.0426 9.40061 17.9261 8.11503 17.7863 6.85922C17.5778 4.99494 16.0631 3.51645 14.1897 3.42583C12.8951 3.36369 11.5733 3.33132 10.1375 3.33132C8.70175 3.33132 7.37992 3.36369 6.08528 3.42583C4.21193 3.51645 2.6972 4.99623 2.48876 6.85922C2.34765 8.11503 2.23242 9.40061 2.23242 10.7121C2.23242 12.0223 2.34894 13.3091 2.48876 14.5636Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ C(s, [["render", c]]), l = {}, d = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _(r, o) {
  return n(), e("svg", d, o[0] || (o[0] = [
    t("path", {
      d: "M8.38028 8.85335C9.07627 10.303 10.0251 11.6616 11.2266 12.8632C12.4282 14.0648 13.7869 15.0136 15.2365 15.7096C15.3612 15.7694 15.4235 15.7994 15.5024 15.8224C15.7828 15.9041 16.127 15.8454 16.3644 15.6754C16.4313 15.6275 16.4884 15.5704 16.6027 15.4561C16.9523 15.1064 17.1271 14.9316 17.3029 14.8174C17.9658 14.3864 18.8204 14.3864 19.4833 14.8174C19.6591 14.9316 19.8339 15.1064 20.1835 15.4561L20.3783 15.6509C20.9098 16.1824 21.1755 16.4481 21.3198 16.7335C21.6069 17.301 21.6069 17.9713 21.3198 18.5389C21.1755 18.8242 20.9098 19.09 20.3783 19.6214L20.2207 19.779C19.6911 20.3087 19.4263 20.5735 19.0662 20.7757C18.6667 21.0001 18.0462 21.1615 17.588 21.1601C17.1751 21.1589 16.8928 21.0788 16.3284 20.9186C13.295 20.0576 10.4326 18.4332 8.04466 16.0452C5.65668 13.6572 4.03221 10.7948 3.17124 7.76144C3.01103 7.19699 2.93092 6.91477 2.9297 6.50182C2.92833 6.0436 3.08969 5.42311 3.31411 5.0236C3.51636 4.66357 3.78117 4.39876 4.3108 3.86913L4.46843 3.7115C4.99987 3.18006 5.2656 2.91433 5.55098 2.76999C6.11854 2.48292 6.7888 2.48292 7.35636 2.76999C7.64174 2.91433 7.90747 3.18006 8.43891 3.7115L8.63378 3.90637C8.98338 4.25597 9.15819 4.43078 9.27247 4.60655C9.70347 5.26945 9.70347 6.12403 9.27247 6.78692C9.15819 6.96269 8.98338 7.1375 8.63378 7.4871C8.51947 7.60142 8.46231 7.65857 8.41447 7.72538C8.24446 7.96281 8.18576 8.30707 8.26748 8.58743C8.29048 8.66632 8.32041 8.72866 8.38028 8.85335Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const a = /* @__PURE__ */ C(l, [["render", _]]);
export {
  u as C,
  a as P
};
